import { useEffect, useState } from "react";
import { io } from "socket.io-client";
import config from "../config";
import { apiService } from "../services/apiService";
import { createScoreboardAppearanceSync } from "../services/scoreboardAppearanceSync";
import { DEFAULT_SCOREBOARD_THEME } from "../constants/scoreboardThemes";

export default function useScoreboardAppearance(link) {
  const [theme, setTheme] = useState(DEFAULT_SCOREBOARD_THEME);
  useEffect(() => {
    if (!link) return;
    setTheme(DEFAULT_SCOREBOARD_THEME);
    const controllers = new Set();
    const socket = io(config.SOCKET_URL, {
      autoConnect: false,
      transports: ["polling", "websocket"],
      reconnection: true,
    });
    const sync = createScoreboardAppearanceSync({
      socket,
      load: async () => {
        const controller = new AbortController();
        controllers.add(controller);
        const timeout = setTimeout(() => controller.abort(), 10000);
        try {
          const result = await apiService.request("/public/scoreboard-theme", {
            method: "POST",
            body: JSON.stringify({ link }),
            signal: controller.signal,
            skipOfflineQueue: true,
          });
          if (!result.success) throw new Error("Appearance unavailable");
          return result.appearance;
        } finally {
          clearTimeout(timeout);
          controllers.delete(controller);
        }
      },
      onChange: (value) => setTheme(value.theme),
    });
    const resume = () => {
      if (!document.hidden) sync.refresh();
    };
    window.addEventListener("online", resume);
    document.addEventListener("visibilitychange", resume);
    return () => {
      sync.dispose();
      controllers.forEach((controller) => controller.abort());
      window.removeEventListener("online", resume);
      document.removeEventListener("visibilitychange", resume);
    };
  }, [link]);
  return theme;
}
